import { ErrorBoundary } from '@datadog/browser-rum-react'
import type { ReactNode } from 'react'

function ErrorFallback(): JSX.Element {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      Something went wrong. Please refresh the page.
    </div>
  )
}

export function DatadogErrorBoundary({ children }: { children: ReactNode }): JSX.Element {
  return (
    <ErrorBoundary fallback={ErrorFallback}>
      {children}
    </ErrorBoundary>
  )
}
